import React from 'react';
//Libs externas
import store from './store';
import { Provider } from 'react-redux';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
//rotas
import Routes from './routes';
//componentes
import TrackNPS from 'components/TrackNPS';
import Toastify from 'components/Toastify';
import { reactPlugin } from './components/ApplicationInsights';
//contexts
import { TabsContextProvider } from 'contexts/Tabs';

const App: React.FC = () => (
  <Provider store={store}>
    <Toastify />
    <TabsContextProvider>
      <Routes />
    </TabsContextProvider>
    <TrackNPS />
  </Provider>
);

export default withAITracking(reactPlugin, App);
